import { FormInstance, Row, DatePicker, Form } from "antd";
import dayjs from "../../../../../../../../configs/dayjs";
import { Link } from "react-router-dom";
import {
  DATE_FORMAT,
  DUE_DATE_REQUIRED,
} from "../../../../../../../../lib/constants";
import { useCallback, useMemo } from "react";
import ROUTES from "../../../../../../../../configs/routesConfig";
import { Rule } from "antd/es/form";
import { CustomerInputSearch } from "../../../../../../../../components/CustomerInputSearch";
import { EnterTooltip } from "../../../../../../../AdminPayment/components/EnterTooltip";

type TSidePanelProps = {
  accountNumber: number;
  instance: any;
  contractId: string;
  isPaymentEdited: boolean;
  form: FormInstance;
  isDisabled: boolean;
  paymentId: string | null;
};

export const SidePanel = ({
  accountNumber,
  instance,
  contractId,
  isPaymentEdited,
  form,
  isDisabled,
  paymentId,
}: TSidePanelProps) => {
  const additionalLabelClass = useCallback(
    (isClassNeeded: boolean): string => (isClassNeeded ? "pt-1" : ""),
    [],
  );

  const dateRules: Rule[] = useMemo(
    () => [
      {
        type: "date",
        required: true,
        validateTrigger: "onSubmit",
        message: DUE_DATE_REQUIRED,
      },
    ],
    [],
  );

  const getRow = useCallback(
    (label: string, value: any, shouldInputAppear = false) => {
      return (
        <Row className="d-flex mb-4">
          <p
            className={`side-panel-label text-md title ma-0 ${additionalLabelClass(
              isPaymentEdited && shouldInputAppear,
            )}`}
          >
            {label}
          </p>
          {isPaymentEdited && shouldInputAppear ? (
            <Form.Item
              className="side-panel-value"
              name="dueDate"
              rules={dateRules}
            >
              <DatePicker
                format={DATE_FORMAT}
                className="w-100"
                placeholder="MM/DD/YY"
              />
            </Form.Item>
          ) : (
            <p className="side-panel-value pl-2 ma-0 text-md w-500 elipsis">
              {value}
            </p>
          )}
        </Row>
      );
    },
    [additionalLabelClass, dateRules, isPaymentEdited],
  );

  return (
    <Form
      form={form}
      disabled={isDisabled}
      className="payment-history-record-side-panel d-flex flex-column pt-4 pr-4"
    >
      {isPaymentEdited && <EnterTooltip />}
      <p className="mt-4 mb-0 text-sm w-500 title ls-5">ACCOUNT</p>
      <Link
        to={`${ROUTES.ACCOUNTS}/${contractId}`}
        target="_blank"
        className="customer-link elipsis my-4"
      >
        <h4 className="h h4 ant-btn-link mr-4">{accountNumber}</h4>
      </Link>
      <Row className="d-flex mb-4">
        <p
          className={`side-panel-label text-md title ma-0 ${additionalLabelClass(
            isPaymentEdited,
          )}`}
        >
          Payer
        </p>
        {!isPaymentEdited ? (
          <Link
            to={`${ROUTES.CUSTOMERS}/${instance?.payerId}`}
            className="ant-btn-link elipsis side-panel-value pl-2 ma-0"
            target="_blank"
          >
            {instance?.payerName}
          </Link>
        ) : (
          <CustomerInputSearch
            form={form}
            label=""
            name="payerNumber"
            isFormDisabled={isDisabled}
            additionalClass="side-panel-value payee-input"
            idItemName="payerId"
          />
        )}
      </Row>
      {getRow(
        "Due Date",
        instance
          ? instance.dueDate
            ? dayjs(instance.dueDate).format(DATE_FORMAT)
            : "-"
          : "",
        true,
      )}
      {paymentId !== null && (
        <>
          <Row className="divider mt-4 mb-8"></Row>
          {isPaymentEdited && (
            <>
              {getRow(
                "Last Updated Date",
                instance ? dayjs(instance.lastUpdated).format(DATE_FORMAT) : "",
              )}
              {getRow("Last Updated By", instance?.lastUpdatedBy)}
            </>
          )}
          {getRow(
            "Created Date",
            instance ? dayjs(instance.added).format(DATE_FORMAT) : "",
          )}
          {getRow("Created By", instance?.addedBy)}
        </>
      )}
    </Form>
  );
};
